export enum UserRoles {
  SUPER_ADMIN = '00000000-0000-0000-0000-000000000000',
  ADMIN = '00000000-0000-0000-0000-000000000001',
  GUEST = '00000000-0000-0000-0000-000000000002',
  MARKET_ADMIN = '00000000-0000-0000-0000-000000000003',
  AGENT = '00000000-0000-0000-0000-000000000004',
  SELLER = '00000000-0000-0000-0000-000000000005',
  RETAILER = '00000000-0000-0000-0000-000000000006',
  GENERIC_SELLER = '00000000-0000-0000-0000-000000000007',
  MASTER_RETAILER = '00000000-0000-0000-0000-000000000008',
  REPAIR = '00000000-0000-0000-0000-000000000009'
}
